import React from "react";

const addedOn = (value) => {
  const time = Date.parse(value || "");
  if (!time) return "";
  return new Date(time).toLocaleDateString();
};

const DuplicateBowlerGroups = ({ groups, onMerge }) => {
  if (!groups?.length) {
    return (
      <p className="text-sm text-brand-muted">No likely duplicates.</p>
    );
  }

  return (
    <div className="space-y-4">
      {groups.map((group) => (
        <div
          key={group.id}
          className="border border-brand-charcoal/10 rounded-lg p-4 space-y-3"
        >
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
            <div>
              <p className="font-medium text-brand-charcoal">
                {group.bowlers[0]?.name}
              </p>
              <p className="text-sm text-brand-muted">
                {group.bowlers.length} bowlers
                {group.reasons.length ? ` · ${group.reasons.join(" · ")}` : ""}
              </p>
            </div>
            <button
              type="button"
              onClick={() =>
                onMerge({
                  keepId: group.bowlers[0]?.id,
                  absorbId: group.bowlers[1]?.id,
                })
              }
              className="px-3 py-2 text-sm font-display font-bold text-brand-charcoal bg-brand-gold rounded-lg hover:bg-brand-gold/90"
            >
              Merge
            </button>
          </div>
          <ul className="text-sm text-brand-charcoal space-y-1">
            {group.bowlers.map((bowler) => (
              <li key={bowler.id}>
                {bowler.name}
                {bowler.usbcID ? ` · USBC ID ${bowler.usbcID}` : " · No USBC ID"}
                {addedOn(bowler.created_at) ? ` · Added ${addedOn(bowler.created_at)}` : ""}
                {` · ${bowler.analytics?.tournamentsBowled || 0} tournaments`}
              </li>
            ))}
          </ul>
          {group.bowlers.length > 2 ? (
            <p className="text-sm text-brand-muted">Merge one bowler at a time.</p>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default DuplicateBowlerGroups;
